import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import type { HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_VERSION } from '@app/version.constant';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  private readonly backendVersionStorageKey = 'site_version';

  private getBackendVersionFromStorage(): string | null {
    const rawBackendVersion = localStorage.getItem(this.backendVersionStorageKey);
    if (!rawBackendVersion) return null;

    try {
      const parsed = JSON.parse(rawBackendVersion);
      return parsed?.version || parsed || null;
    } catch {
      return rawBackendVersion;
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const frontendVersion = APP_VERSION?.frontend || 'unknown';
    const backendVersion = this.getBackendVersionFromStorage();
    const versionHeaders: Record<string, string> = {
      'X-Frontend-Version': frontendVersion,
    };
    if (backendVersion) {
      versionHeaders['X-Backend-Version'] = backendVersion;
    }
    const requestWithVersion = request.clone({
      setHeaders: versionHeaders,
    });

    return next.handle(requestWithVersion);
  }
}
